import { connect } from 'react-redux';
import { Props } from './App';
import { appMounted } from '../../../actions/app';

export type StateProps = Pick<Props, never>;
export type DispatchProps = Pick<Props, 'appMounted'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapDispatchToProps: DispatchProps = {
  appMounted,
};

export default connect(null, mapDispatchToProps);
